export default __webpack_public_path__ + "static/media/pixellab--web-design--01a--1200x900.f2b6359a.jpg";